module.exports = __webpack_public_path__ + "img/inst-modal-18.02e9d52b.png";